module.exports = __webpack_public_path__ + "static/media/es-pv.c3050ef4.svg";